export default "__VITE_ASSET__C7L0M2zZ__"